import React from "react";
import "./Contact.css";
import mailIcon from "../assets/images/icon-mail-blue.svg";

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <div className="contact-content">
          <div className="contact-text">
            <h2 className="contact-title">
              Ready to Transform Your Operations?
            </h2>
            <p className="contact-description">
              Connect with our team to explore how RIPE can revolutionize your
              mission planning and execution.
            </p>
          </div>
          <div className="contact-action">
            <a
              href="mailto:JOuellette@versar.com&subject=Ripe Versar&body=Let's Connect"
              className="contact-button"
            >
              <img src={mailIcon} alt="Mail" width="40" />
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
